import { PaymentMethodSummary } from '../../shared/models/payment-method-summary';
import { Component, Input } from '@angular/core';
import { UserService, Store, StoreHelper } from '../../../shared/services';
import { TopLevelComponent } from '../../../shared/models';

@Component({
    selector: 'my-payment-details',
     styles: [require('./payment-details.component.scss')],
    template: require('./payment-details.component.pug')
})

export class PaymentDetailsComponent extends TopLevelComponent {
    @Input() paymentSummary: PaymentMethodSummary;
    @Input() empty: boolean;

     constructor(
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService) {

        super(store, storeHelper, userService);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/payment/payment-details/payment-details.component.ts